import React from 'react';
import { useTranslation } from 'react-i18next';
import './ViewModeToggle.css';

const VIEW_MODES = [
  { id: 'list', icon: 'view_list', labelKey: 'viewMode.list' },
  { id: 'grid', icon: 'grid_view', labelKey: 'viewMode.grid' },
  { id: 'cards', icon: 'view_agenda', labelKey: 'viewMode.cards' },
];

function ViewModeToggle({ viewMode, onChange }) {
  const { t } = useTranslation();
  return (
    <div className="view-mode-toggle" role="group" aria-label={t('viewMode.groupLabel')}>
      {VIEW_MODES.map((mode) => (
        <button
          key={mode.id}
          className={`view-mode-btn ${viewMode === mode.id ? 'active' : ''}`}
          onClick={() => onChange(mode.id)}
          title={t(mode.labelKey)}
          aria-label={t(mode.labelKey)}
          aria-pressed={viewMode === mode.id}
        >
          <span className="material-icons" aria-hidden="true">{mode.icon}</span>
        </button>
      ))}
    </div>
  );
}

export default ViewModeToggle;
